export const CREATING_PATIENT = 'creatingPatient'

const createHumanName = ({ given, family }) => {
  return [
    {
      use: 'official',
      family,
      given: [given]
    }
  ]
}

const createTelecom = ({ email, phone }) => {
  return [
    {
      system: 'phone',
      value: phone
    },
    {
      system: 'email',
      value: email
    }
  ]
}
const createAddress = ({ address, country, city, postCode }) => {
  return [
    {
      text: `${address}, ${city}, ${country}, ${postCode}`,
      line: [address],
      city,
      country,
      postalCode: postCode
    }
  ]
}
const createIdentifier = ({ socialSecurityNo }) => {
  return [
    {
      use: 'usual',
      type: {
        coding: [
          {
            system: 'http://hl7.org/fhir/v2/0203',
            code: 'SS'
          }
        ],
        value: socialSecurityNo
      }
    }
  ]
}

export const createPatient = patientInfo => {
  const patient = {
    resourceType: 'Patient',
    ...(patientInfo.id != null && { id: patientInfo.id }),
    active: true,
    identifier: createIdentifier(patientInfo),
    name: createHumanName(patientInfo),
    telecom: createTelecom(patientInfo),
    birthDate: patientInfo.birthDate,
    address: createAddress(patientInfo),
    generalPractitioner: {
      display: patientInfo.practitioner
    },
    managingOrganization: {
      display: 'medeo'
    }
  }

  return {
    type: CREATING_PATIENT,
    payload: patient
  }
}



// WEBPACK FOOTER //
// ./src/Patients/actions.js